import React from "react";
import {
  SearchInputContainer,
  SearchInput as StyledSearchInput,
} from "../Select.styles";

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Buscar...",
  inputRef,
}) => {
  return (
    <SearchInputContainer>
      <StyledSearchInput
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="off"
      />
    </SearchInputContainer>
  );
};
